import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './Settings.css';
import Navbar from '../Navbar/Navbar';
import TopBar from '../Navbar/Mainbar.jsx';

// initials helper
const _getInit = (name) => name ? name.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2) : 'A';


const SystemSettings = () => {
  const [leavePolicy, setLeavePolicy] = useState({
    casualLeave: '10',
    medicalLeave: '10',
    permissionRequests: '01',
    casualCarryforward: '07'
  });

  const [emailConfig, setEmailConfig] = useState({
    smtpServer: 'smtp.gmail.com',
    smtpPort: '587',
    fromEmail: 'sriram.l@manureavasolutions.net',
    fromName: 'sriram lokesh',
    emailPassword: 'thpinzxjctplmlbs',
    useTls: true,
    useSsl: false
  });

  const [security, setSecurity] = useState({
    twoFactor: false,
    sessionTimeout: '30 minutes',
    passwordExpiry: 'Never',
    loginAttempts: '5'
  });

  const [backup, setBackup] = useState({
    frequency: 'Every 6 hours',
    retention: '7 days'
  });

  // Autocomplete states
  const [emailSuggestions, setEmailSuggestions] = useState([]);
  const [nameSuggestions, setNameSuggestions] = useState([]);
  const [showEmailDropdown, setShowEmailDropdown] = useState(false);
  const [showNameDropdown, setShowNameDropdown] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ show: false, type: '', message: '' });
  const [selectedUser, setSelectedUser] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  
  
  // Test email states
  const [testEmailStatus, setTestEmailStatus] = useState({ show: false, type: '', message: '' });
  const [isSendingTest, setIsSendingTest] = useState(false);

  // Leave Policy Modal states
  const [showLeavePolicyModal, setShowLeavePolicyModal] = useState(false);
  const [selectedPolicyType, setSelectedPolicyType] = useState(null);
  const [employeeListForPolicy, setEmployeeListForPolicy] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [policyModalData, setPolicyModalData] = useState({
    casual: [],
    medical: [],
    permission: [],
    carryforward: [],
    extra: []
  });

  // States for editing individual leave limits
  const [editingEmployeeId, setEditingEmployeeId] = useState(null);
  const [editingLimit, setEditingLimit] = useState('');
  const [editingExtraLimit, setEditingExtraLimit] = useState('');
  const [editingFieldType, setEditingFieldType] = useState(null);
  const [updatingLimit, setUpdatingLimit] = useState(false);

  // Email Composer states
  const [showEmailComposer, setShowEmailComposer] = useState(false);
  const [emailComposer, setEmailComposer] = useState({
    recipientEmail: '',
    recipientName: '',
    subject: '',
    body: '',
    emailType: 'custom'
  });
  
  const [composerLoading, setComposerLoading] = useState(false);
  const [composerStatus, setComposerStatus] = useState({ show: false, type: '', message: '' });

  // Ã°Å¸â€Â SEARCH STATES
  const [searchQuery, setSearchQuery] = useState('');
  const [highlightedFields, setHighlightedFields] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);

  const emailInputRef = useRef(null);
  const nameInputRef = useRef(null);
  const emailDropdownRef = useRef(null);
  const nameDropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const modalScrollRef = useRef(null);

  // Backend URL
  const BACKEND_URL = process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'production' 
      ? 'https://api.leave-management.manurevasolutions.com' 
      : 'http://localhost:5000');

  // Ã°Å¸â€Â SEARCHABLE CONTENT MAPPING
  const searchableContent = {
    'leave-policy': {
      title: 'Leave Policy Configuration',
      keywords: ['leave', 'policy', 'casual', 'medical', 'permission', 'annual', 'days', 'carryforward', 'vacation', 'sick', 'emergency'],
      element: 'admin-settings-leave-policy',
      description: 'Configure annual leave days, medical leave, and permission requests'
    },
    'email-config': {
      title: 'Email Configuration',
      keywords: ['email', 'smtp', 'mail', 'server', 'port', 'password', 'sender', 'configuration', 'notification', 'send'],
      element: 'admin-settings-email-config',
      description: 'Configure SMTP server settings for sending emails'
    },
    'security': {
      title: 'Security Settings',
      keywords: ['security', 'password', 'authentication', '2fa', 'two-factor', 'session', 'timeout', 'login', 'logout'],
      element: 'admin-settings-security-settings',
      description: 'Configure authentication and session security'
    },
    'backup': {
      title: 'Backup & Recovery',
      keywords: ['backup', 'recovery', 'restore', 'retention', 'frequency', 'data', 'save'],
      element: 'admin-settings-backup-recovery',
      description: 'Configure automated backup frequency and retention'
    }
  };

  // Fetch all users on component mount
  useEffect(() => {
    fetchAllUsers();
  }, []);

  // Fetch email config after users are loaded
  useEffect(() => {
    if (allUsers.length > 0) {
      fetchCurrentEmailConfig();
    }
  }, [allUsers]);

  // ============================================
  // FIXED: Close dropdowns when clicking outside
  // ============================================
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Email dropdown
      if (emailDropdownRef.current && !emailDropdownRef.current.contains(event.target) &&
          emailInputRef.current && !emailInputRef.current.contains(event.target)) {
        setShowEmailDropdown(false);
      }
      
      // Name dropdown
      if (nameDropdownRef.current && !nameDropdownRef.current.contains(event.target) &&
          nameInputRef.current && !nameInputRef.current.contains(event.target)) {
        setShowNameDropdown(false);
      }
      
      // FIXED: Search results dropdown - Better conflict resolution
      const searchContainer = searchInputRef.current?.closest('.admin-settings-search-container');
      if (searchContainer && !searchContainer.contains(event.target)) {
        setShowSearchResults(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // ============================================
  // FIXED: SEARCH HANDLER with Weighted Scoring
  // ============================================
  const handleSearch = (query) => {
    setSearchQuery(query);
    
    if (!query.trim()) {
      setHighlightedFields([]);
      setShowSearchResults(false);
      return;
    }

    setShowSearchResults(true);
    const lowerQuery = query.toLowerCase().trim();
    const matches = [];

    Object.entries(searchableContent).forEach(([key, section]) => {
      let score = 0;
      
      // Title match = highest priority (20 points)
      if (section.title.toLowerCase().includes(lowerQuery)) {
        score += 20;
      }
      
      // Description match = medium priority (10 points)
      if (section.description.toLowerCase().includes(lowerQuery)) {
        score += 10;
      }
      
      // Keyword matches = accumulative (3 points each)
      const keywordMatches = section.keywords.filter(keyword => 
        keyword.toLowerCase().includes(lowerQuery) || 
        lowerQuery.includes(keyword.toLowerCase())
      ).length;
      score += keywordMatches * 3;

      if (score > 0) {
        matches.push({ key, section, score });
      }
    });

    if (matches.length > 0) {
      matches.sort((a, b) => b.score - a.score);
      setHighlightedFields(matches.map(m => m.key));
    } else {
      setHighlightedFields([]);
    }
  };

  // ============================================
  // FIXED: SCROLL TO SECTION with Better Animation
  // ============================================
  const scrollToSection = (sectionKey) => {
    const section = searchableContent[sectionKey];
    if (!section) return;

    // Close dropdown immediately
    setShowSearchResults(false);
    
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      const element = document.querySelector(`.${section.element}`);
      if (element) {
        // FIXED: Calculate position with offset for fixed headers
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 100;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        
        // FIXED: Enhanced highlight animation with shadow
        element.style.transition = 'all 0.3s ease';
        element.style.backgroundColor = '#fff3cd';
        element.style.border = '2px solid #ffc107';
        element.style.boxShadow = '0 0 20px rgba(255, 193, 7, 0.5)';
        
        // FIXED: Remove highlight after 2.5 seconds (increased from 2s)
        setTimeout(() => {
          element.style.backgroundColor = '';
          element.style.border = '';
          element.style.boxShadow = '';
        }, 2500);
      }
    }, 100);
    
    // Clear search after navigation
    setTimeout(() => {
      setSearchQuery('');
      setHighlightedFields([]);
    }, 150);
  };

  // Ã°Å¸â€Â CLEAR SEARCH
  const clearSearch = () => {
    setSearchQuery('');
    setHighlightedFields([]);
    setShowSearchResults(false);
  };

  const fetchAllUsers = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/employee-list`, {
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const users = await response.json();
        setAllUsers(users);
        console.log('Ã¢Å“â€¦ Loaded', users.length, 'users for autocomplete');
      }
    } catch (error) {
      console.error('Ã¢ÂÅ’ Error fetching users:', error);
    }
  };

  const fetchCurrentEmailConfig = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/settings/email-config`, {
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const config = await response.json();
        
        setEmailConfig({
          smtpServer: config.smtpServer || 'smtp.gmail.com',
          smtpPort: config.smtpPort?.toString() || '587',
          fromEmail: config.fromEmail || '',
          fromName: config.fromName || '',
          selectedUserId: config.selectedUserId,
          emailPassword: '',
          useTls: config.useTls !== false,
          useSsl: config.useSsl === true
        });
        
        if (config.selectedUserId) {
          const user = allUsers.find(u => u.id === config.selectedUserId);
          if (user) {
            setSelectedUser(user);
            console.log('Ã¢Å“â€¦ Current email sender:', user.name, `(${user.email})`);
          }
        }
      }
    } catch (error) {
      console.error('Ã¢ÂÅ’ Error fetching email config:', error);
    }
  };

  const fetchEmployeesByRole = async (policyType) => {
    console.log('Ã°Å¸â€â€ž [FETCH] Starting fetchEmployeesByRole for policyType:', policyType);
    setLoadingEmployees(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/employee-list?_=${Date.now()}`, {
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        cache: 'no-cache' // Ã¢Å“â€¦ Ensure fresh data
      });

      if (response.ok) {
        const users = await response.json();
        console.log('Ã°Å¸â€œÂ¥ [FETCH] Got', users.length, 'users from employee-list');
        
        const employees = users.filter(user => 
          user.role && user.role.toLowerCase() === 'employee'
        );
        
        console.log('Ã°Å¸â€˜Â¥ [FETCH] Filtered to', employees.length, 'employees');

        const employeesWithBalance = await Promise.all(
  employees.map(async (emp) => {
    try {
      const balanceResponse = await fetch(`${BACKEND_URL}/api/employee/${emp.id}/leave-balance?_=${Date.now()}`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        cache: 'no-cache'
      });

      if (balanceResponse.ok) {
  const balanceData = await balanceResponse.json();
  
  // ✅ CRITICAL DEBUG: Show the EXACT structure
  console.log(`🔍 [FETCH] Employee ${emp.id} FULL JSON:`, JSON.stringify(balanceData, null, 2));
  
  // Check what's inside casual
  if (balanceData.balances && balanceData.balances.casual) {
    console.log(`🎯 [CASUAL ONLY] Employee ${emp.id}:`, balanceData.balances.casual);
    console.log(`   - used field exists? ${balanceData.balances.casual.hasOwnProperty('used')}`);
    console.log(`   - used value: ${balanceData.balances.casual.used}`);
  }
  
  return {
    ...emp,
    leaveBalance: balanceData.balances || {}
  };
}
    } catch (error) {
      console.error(`Error fetching balance for employee ${emp.id}:`, error);
    }
    return emp;
  })
);

        setPolicyModalData(prevData => {
          const newData = {
            ...prevData,
            [policyType]: employeesWithBalance
          };
          console.log('Ã¢Å“â€¦ [FETCH] Updated policyModalData for', policyType, '- stored', employeesWithBalance.length, 'employees');
          return newData;
        });

        console.log('Ã¢Å“â€¦ Loaded', employeesWithBalance.length, 'employees for policy display');
      }
    } catch (error) {
      console.error('Ã¢ÂÅ’ Error fetching employees:', error);
    } finally {
      setLoadingEmployees(false);
    }
  };

  const handleOpenPolicyModal = (policyType) => {
    setSelectedPolicyType(policyType);
    setShowLeavePolicyModal(true);
    fetchEmployeesByRole(policyType);
  };

  const saveIndividualLimit = async (employeeId, newLimit, leaveType, extraLimit = null) => {
    try {
      const limitValue = parseFloat(newLimit);
      if (isNaN(limitValue) || limitValue < 0 || limitValue > 365) {
        setSaveStatus({
          show: true,
          type: 'error',
          message: '❌ Limit must be between 0 and 365 days'
        });
        setTimeout(() => setSaveStatus({ show: false, type: '', message: '' }), 3000);
        return;
      }

      // Validate extra limit if provided
      if (extraLimit !== null) {
        const extraLimitValue = parseFloat(extraLimit);
        if (isNaN(extraLimitValue) || extraLimitValue < 0 || extraLimitValue > 365) {
          setSaveStatus({
            show: true,
            type: 'error',
            message: '❌ Carry-forwarded limit must be between 0 and 365 days'
          });
          setTimeout(() => setSaveStatus({ show: false, type: '', message: '' }), 3000);
          return;
        }
      }

      setUpdatingLimit(true);
      setSaveStatus({ 
        show: true, 
        type: 'info', 
        message: '⏳ Updating leave limits...' 
      });
      
      // If both limits are being updated (casual leave case)
      if (extraLimit !== null && leaveType === 'carryforward') {
        // Update carry-forward first
        const carryforwardResponse = await fetch(`${BACKEND_URL}/api/employee/${employeeId}/update-leave-limit`, {
          method: 'PUT',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            leaveType: 'casual',
            newLimit: limitValue,
            isCarryforward: true,
            isExtraLeave: false
          })
        });

        if (!carryforwardResponse.ok) {
          throw new Error('Failed to update carry-forward limit');
        }

        // Then update extra leave
        const extraLeaveResponse = await fetch(`${BACKEND_URL}/api/employee/${employeeId}/update-leave-limit`, {
          method: 'PUT',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            leaveType: 'casual',
            newLimit: parseFloat(extraLimit),
            isCarryforward: false,
            isExtraLeave: true
          })
        });

        if (!extraLeaveResponse.ok) {
          throw new Error('Failed to update earned leave limit');
        }

        setSaveStatus({
          show: true,
          type: 'success',
          message: '✅ Both limits updated successfully!'
        });
      } else {
        // Single field update (original logic)
        const isCarryforwardUpdate = leaveType === 'carryforward';
        const isExtraLeaveUpdate = leaveType === 'extra';
        
        const requestBody = {
          leaveType: isCarryforwardUpdate || isExtraLeaveUpdate ? 'casual' : leaveType,
          newLimit: limitValue,
          isCarryforward: isCarryforwardUpdate,
          isExtraLeave: isExtraLeaveUpdate
        };
        
        const response = await fetch(`${BACKEND_URL}/api/employee/${employeeId}/update-leave-limit`, {
          method: 'PUT',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.error || 'Failed to update limit');
        }

        setSaveStatus({
          show: true,
          type: 'success',
          message: '✅ Leave limit updated successfully!'
        });
      }
      
      console.log('🔄 [SETTINGS] Fetching updated employee data for policyType:', selectedPolicyType);
      await new Promise(resolve => setTimeout(resolve, 500));
      await fetchEmployeesByRole(selectedPolicyType);
      console.log('✅ [SETTINGS] Employee data refreshed');
      
      setEditingEmployeeId(null);
      setEditingLimit('');
      setEditingExtraLimit('');
      setEditingFieldType(null);
      
      const event = new CustomEvent('leaveBalanceAdjusted', {
        detail: {
          employeeId: employeeId,
          leaveType: leaveType,
          newLimit: limitValue,
          updateType: 'individual_limit_update'
        }
      });
      
      window.dispatchEvent(event);
      console.log('📢 Broadcasted leaveBalanceAdjusted event');
      
      setTimeout(() => {
        setSaveStatus({ show: false, type: '', message: '' });
      }, 3000);
    } catch (error) {
      console.error('❌ Error updating individual limit:', error);
      setSaveStatus({
        show: true,
        type: 'error',
        message: `❌ ${error.message}`
      });
      setTimeout(() => setSaveStatus({ show: false, type: '', message: '' }), 5000);
    } finally {
      setUpdatingLimit(false);
    }
  };

  const handleEmailInput = (value) => {
    setEmailConfig({ ...emailConfig, fromEmail: value });

    if (value.length > 0) {
      const filtered = allUsers.filter(user => 
        user.email.toLowerCase().includes(value.toLowerCase())
      );
      setEmailSuggestions(filtered);
      setShowEmailDropdown(filtered.length > 0);
    } else {
      setShowEmailDropdown(false);
    }
  };

  const handleNameInput = (value) => {
    setEmailConfig({ ...emailConfig, fromName: value });

    if (value.length > 0) {
      const filtered = allUsers.filter(user => 
        user.name.toLowerCase().includes(value.toLowerCase())
      );
      setNameSuggestions(filtered);
      setShowNameDropdown(filtered.length > 0);
    } else {
      setShowNameDropdown(false);
    }
  };

  const selectEmailSuggestion = (user) => {
    setEmailConfig({
      ...emailConfig,
      fromEmail: user.email,
      fromName: user.name,
      selectedUserId: user.id
    });
    setSelectedUser(user);
    setShowEmailDropdown(false);
    console.log('Ã¢Å“â€¦ Selected user:', user.name, user.id);
  };

  const selectNameSuggestion = (user) => {
    setEmailConfig({
      ...emailConfig,
      fromName: user.name,
      fromEmail: user.email,
      selectedUserId: user.id
    });
    setSelectedUser(user);
    setShowNameDropdown(false);
    console.log('Ã¢Å“â€¦ Selected user:', user.name, user.id);
  };

  const sendTestEmail = async () => {
    if (!emailConfig.selectedUserId) {
      setTestEmailStatus({
        show: true,
        type: 'error',
        message: 'Ã¢Å¡ Ã¯Â¸Â Please save your email configuration first before sending test email'
      });
      setTimeout(() => {
        setTestEmailStatus({ show: false, type: '', message: '' });
      }, 5000);
      return;
    }

    if (!emailConfig.emailPassword) {
      setTestEmailStatus({
        show: true,
        type: 'error',
        message: 'Ã¢Å¡ Ã¯Â¸Â Please enter email password and save configuration first'
      });
      setTimeout(() => {
        setTestEmailStatus({ show: false, type: '', message: '' });
      }, 5000);
      return;
    }

    setIsSendingTest(true);
    setTestEmailStatus({ show: false, type: '', message: '' });

    try {
      const response = await fetch(`${BACKEND_URL}/api/test-email`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          smtpServer: emailConfig.smtpServer,
          smtpPort: parseInt(emailConfig.smtpPort),
          fromEmail: emailConfig.fromEmail,
          fromName: emailConfig.fromName,
          emailPassword: emailConfig.emailPassword,
          recipientEmail: emailConfig.fromEmail,
          useTls: emailConfig.useTls,
          useSsl: emailConfig.useSsl
        })
      });

      if (response.ok) {
        const result = await response.json();
        
        setTestEmailStatus({
          show: true,
          type: 'success',
          message: `Ã¢Å“â€¦ ${result.message || 'Test email sent successfully! Check your inbox.'}`
        });
        
        setTimeout(() => {
          setTestEmailStatus({ show: false, type: '', message: '' });
        }, 8000);
      } else {
        const error = await response.json();
        setTestEmailStatus({
          show: true,
          type: 'error',
          message: `Ã¢ÂÅ’ ${error.error || 'Failed to send test email'}\n${error.details || error.message || ''}`
        });
        
        setTimeout(() => {
          setTestEmailStatus({ show: false, type: '', message: '' });
        }, 8000);
      }
    } catch (error) {
      console.error('Ã¢ÂÅ’ Error sending test email:', error);
      setTestEmailStatus({
        show: true,
        type: 'error',
        message: `Ã¢ÂÅ’ Network error: ${error.message || 'Please check your connection and try again.'}`
      });
      
      setTimeout(() => {
        setTestEmailStatus({ show: false, type: '', message: '' });
      }, 5000);
    } finally {
      setIsSendingTest(false);
    }
  };

  const saveEmailConfiguration = async () => {
    if (!emailConfig.selectedUserId) {
      setSaveStatus({
        show: true,
        type: 'error',
        message: 'Ã¢ÂÅ’ Please select a user from the autocomplete dropdown'
      });
      return;
    }

    if (!emailConfig.smtpServer || emailConfig.smtpServer.trim() === '') {
      setSaveStatus({
        show: true,
        type: 'error',
        message: 'Ã¢ÂÅ’ SMTP Server is required'
      });
      return;
    }

    if (!emailConfig.fromEmail || !emailConfig.fromEmail.includes('@')) {
      setSaveStatus({
        show: true,
        type: 'error',
        message: 'Ã¢ÂÅ’ Valid email address is required'
      });
      return;
    }

    if (!emailConfig.emailPassword || emailConfig.emailPassword.length < 6) {
      setSaveStatus({
        show: true,
        type: 'error',
        message: 'Ã¢ÂÅ’ Email password is required (minimum 6 characters). For Gmail, use App Password.'
      });
      return;
    }

    setLoading(true);
    setSaveStatus({ show: false, type: '', message: '' });

    try {
      const response = await fetch(`${BACKEND_URL}/api/update-email-config`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          smtpServer: emailConfig.smtpServer.trim(),
          smtpPort: parseInt(emailConfig.smtpPort),
          selectedUserId: emailConfig.selectedUserId,
          fromEmail: emailConfig.fromEmail.trim(),
          fromName: emailConfig.fromName.trim(),
          emailPassword: emailConfig.emailPassword,
          useTls: emailConfig.useTls,
          useSsl: emailConfig.useSsl
        })
      });

      if (response.ok) {
        const result = await response.json();
        
        setSaveStatus({
          show: true,
          type: 'success',
          message: `Ã¢Å“â€¦ ${result.message || 'Email configuration saved successfully!'}`
        });
        
        setTimeout(() => {
          setSaveStatus({ show: false, type: '', message: '' });
        }, 5000);
      } else {
        const error = await response.json();
        setSaveStatus({
          show: true,
          type: 'error',
          message: `Ã¢ÂÅ’ Failed to save: ${error.error || 'Unknown error'}\n${error.details || error.message || ''}`
        });
      }
    } catch (error) {
      console.error('Ã¢ÂÅ’ Error saving email config:', error);
      setSaveStatus({
        show: true,
        type: 'error',
        message: `Ã¢ÂÅ’ Connection error: ${error.message || 'Please check your connection and try again.'}`
      });
    } finally {
      setLoading(false);
    }
  };

  const autocorrectSMTP = (value) => {
    const corrections = {
      'smpt.gmail.com': 'smtp.gmail.com',
      'stmp.gmail.com': 'smtp.gmail.com',
      'smtps.gmail.com': 'smtp.gmail.com',
      'mail.gmail.com': 'smtp.gmail.com',
      'smpt.office365.com': 'smtp.office365.com',
      'stmp.office365.com': 'smtp.office365.com',
      'smpt.mail.yahoo.com': 'smtp.mail.yahoo.com',
      'smpt.aol.com': 'smtp.aol.com',
    };
    
    const cleaned = value.toLowerCase().trim();
    return corrections[cleaned] || value;
  };

  const saveLeavePolicyConfiguration = async () => {
    setLoading(true);
    setSaveStatus({ show: false, type: '', message: '' });

    try {
      const response = await fetch(`${BACKEND_URL}/api/settings/leave-policy`, {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(leavePolicy)
      });

      if (response.ok) {
        const result = await response.json();
        
        setSaveStatus({
          show: true,
          type: 'success',
          message: 'Ã¢Å“â€¦ Leave policy saved successfully!'
        });
        
        const configPayload = {
          policies: {
            casual: { 
              maxDaysPerYear: parseInt(leavePolicy.casualLeave) || 15 
            },
            sick: { 
              maxDaysPerYear: parseInt(leavePolicy.medicalLeave) || 15 
            },
            emergency: { 
              maxApplicationsPerMonth: parseInt(leavePolicy.permissionRequests ?? '2'),
              hoursPerApplication: 2 
            }
          },
          timestamp: new Date().toISOString()
        };
        
        localStorage.setItem('leaveConfiguration', JSON.stringify(configPayload));
        console.log('Ã°Å¸â€™Â¾ Saved config to localStorage:', configPayload);
        
        const event = new CustomEvent('leaveBalanceAdjusted', {
          detail: {
            employeeId: 'all',
            config: configPayload,
            updateType: 'global_policy_update'
          }
        });
        
        window.dispatchEvent(event);
        console.log('Ã°Å¸â€œÂ¢ Broadcasted leaveBalanceAdjusted event with config:', configPayload);
        
        setTimeout(() => {
          setSaveStatus({ show: false, type: '', message: '' });
        }, 3000);
      } else {
        const error = await response.json();
        setSaveStatus({
          show: true,
          type: 'error',
          message: `Ã¢ÂÅ’ Failed to save: ${error.error || 'Unknown error'}`
        });
      }
    } catch (error) {
      console.error('Ã¢ÂÅ’ Error saving leave policy:', error);
      setSaveStatus({
        show: true,
        type: 'error',
        message: 'Ã¢ÂÅ’ Network error. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  const getEmailTemplate = (templateType) => {
    const templates = {
      custom: {
        subject: '',
        body: ''
      },
      approval: {
        subject: 'Leave Request Approved Ã¢Å“â€¦',
        body: `Dear [Employee Name],

Your leave request has been approved.

Ã°Å¸â€œâ€¹ Leave Details:
Ã¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€Â
Leave Type: [Leave Type]
From: [Start Date]
To: [End Date]
Duration: [Number of Days] days
Status: Ã¢Å“â€¦ APPROVED

Please contact your manager if you have any questions.

Best regards,
Leave Management System`
      },
      rejection: {
        subject: 'Leave Request Rejected Ã¢ÂÅ’',
        body: `Dear [Employee Name],

Unfortunately, your leave request has been rejected.

Ã°Å¸â€œâ€¹ Leave Details:
Ã¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€ÂÃ¢â€Â
Leave Type: [Leave Type]
From: [Start Date]
To: [End Date]
Duration: [Number of Days] days
Status: Ã¢ÂÅ’ REJECTED

Reason: [Manager Comments]

Please reach out to your manager to discuss this decision.

Best regards,
Leave Management System`
      },
      notification: {
        subject: 'Important Notification from Leave Management',
        body: `Dear [Employee Name],

[Write your notification message here]

Thank you,
Leave Management System`
      }
    };
    
    return templates[templateType] || templates.custom;
  };

  // Leave Policy Modal Component
  const LeavePolicyModal = ({ policyType, onClose }) => {
    // Lock body scroll when modal is open
    React.useEffect(() => {
      // Save current scroll position
      const scrollY = window.scrollY;
      const scrollX = window.scrollX;
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = `-${scrollX}px`;
      document.body.style.right = '0';
      document.body.style.width = '100%';
      
      // Cleanup function to restore scroll
      return () => {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        
        // Restore scroll position
        window.scrollTo(scrollX, scrollY);
      };
    }, []);

    const getPolicyLabel = () => {
      switch(policyType) {
        case 'casual': return 'Annual Earned Leave Days';
        case 'medical': return 'Annual Medical Leave Days';
        case 'permission': return 'Permission Requests Per Month';
        case 'carryforward': return 'Earned leave Carryforward Limit';
        default: return 'Leave Policy';
      }
    };

    const getPolicyValue = () => {
      switch(policyType) {
        case 'casual': return leavePolicy.casualLeave;
        case 'medical': return leavePolicy.medicalLeave;
        case 'permission': return leavePolicy.permissionRequests;
        case 'carryforward': return leavePolicy.casualCarryforward;
        default: return '0';
      }
    };

    const getEmployeeLimit = (employee) => {
  if (!employee.leaveBalance) return 0;
  
  let limit;
  switch(policyType) {
    case 'casual':
      limit = employee.leaveBalance.casual?.allocated_days || 0;
      break;
    case 'medical':
      limit = employee.leaveBalance.medical?.allocated_days || 0;
      break;
    case 'permission':
      limit = employee.leaveBalance.permission?.permission_monthly_limit || 0;
      break;
    case 'carryforward':
      // ✅ FIX: Show extra_leave_days instead of carry_forward_from_previous_month
      limit = employee.leaveBalance.casual?.extra_leave_days || 0;
      break;
    case 'extra':
      limit = employee.leaveBalance.casual?.extra_leave_days || 0;
      break;
    default:
      limit = 0;
  }
  
  console.log(`🔍 [DISPLAY] Employee ${employee.id} (${employee.name}) - policyType: ${policyType}, limit: ${limit}, full casual balance:`, employee.leaveBalance.casual);
  return limit;
};

    const getEmployeeUsed = (employee) => {
  if (!employee.leaveBalance) {
    console.log(`⚠️ No leaveBalance for employee ${employee.id}`);
    return 0;
  }
  
  let used = 0;
  switch(policyType) {
    case 'casual':
      used = employee.leaveBalance.casual?.used || 0;
      break;
    case 'medical':
      used = employee.leaveBalance.medical?.used || 0;
      break;
    case 'permission':
      used = employee.leaveBalance.permission?.used || 0;
      break;
    case 'carryforward':
      used = employee.leaveBalance.casual?.used || 0;
      break;
    case 'extra':
      used = employee.leaveBalance.casual?.used || 0;
      break;
    default:
      used = 0;
  }
  
  console.log(`📈 [GET USED] Employee ${employee.id} (${employee.name}), type: ${policyType}, used: ${used}, full balance:`, employee.leaveBalance.casual);
  return used;
};

    const getEmployeeRemaining = (employee) => {
  if (!employee.leaveBalance) {
    console.log(`⚠️ No leaveBalance for employee ${employee.id}`);
    return 0;
  }
  
  let remaining = 0;
  switch(policyType) {
    case 'casual':
      // ✅ FIX: Remaining = extra_leave_days + allocated - used (NO auto-accrued)
      const extraLeave = employee.leaveBalance.casual?.extra_leave_days || 0;
      const allocated = employee.leaveBalance.casual?.allocated_days || 0;
      const used = employee.leaveBalance.casual?.used || 0;
      remaining = extraLeave + allocated - used;
      console.log(`🔢 [REMAINING] Employee ${employee.id}: Extra=${extraLeave} + Allocated=${allocated} - Used=${used} = ${remaining}`);
      break;
    case 'medical':
      remaining = employee.leaveBalance.medical?.remaining || 0;
      break;
    case 'permission':
      remaining = employee.leaveBalance.permission?.remaining || 0;
      break;
    case 'carryforward':
      remaining = employee.leaveBalance.casual?.extra_leave_days || 0;
      break;
    case 'extra':
      remaining = employee.leaveBalance.casual?.extra_leave_days || 0;
      break;
    default:
      remaining = 0;
  }
  
  return remaining;
};
    const getEmployees = () => {
      return policyModalData[policyType] || [];
    };

    const employees = getEmployees();
    const policyValue = getPolicyValue();

    return ReactDOM.createPortal(
      <div 
        className="admin-settings-policy-modal-overlay" 
        // onClick={onClose}
        onScroll={(e) => e.preventDefault()}
      >
        <div 
          className="admin-settings-policy-modal" 
          // onClick={(e) => {
          //   e.stopPropagation();
          //   e.preventDefault();
          // }}
          onScroll={(e) => e.stopPropagation()}
        >
          <div className="admin-settings-policy-modal-header">
            <div>
              <h2 className="admin-settings-policy-modal-title">{getPolicyLabel()}</h2>
            </div>
            <button 
              className="admin-settings-policy-modal-close" 
              onClick={onClose}
            >
           ✕
            </button>
          </div>

          <div className="admin-settings-policy-modal-content">
            {loadingEmployees ? (
              <div style={{
                textAlign: 'center',
                padding: '60px 20px',
                color: '#666'
              }}>
                <div style={{ fontSize: '24px', marginBottom: '12px' }}></div>
                <div>Loading employee data...</div>
              </div>
            ) : employees.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '60px 20px',
                color: '#666'
              }}>
                <div style={{ fontSize: '32px', marginBottom: '12px' }}>Ã°Å¸â€Â­</div>
                <div>No employees found</div>
              </div>
            ) : (
              <div className="admin-settings-policy-employees-list">
                <div className="admin-settings-policy-employees-header">
                  <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: policyType === 'casual' ? '2fr 1fr 1fr 1fr 1fr 100px' : '2fr 1fr 1fr 1fr 100px',
                    gap: '16px', 
                    padding: '12px 16px', 
                    fontWeight: '600', 
                    color: '#2A2A2A', 
                    fontSize: '13px', 
                    backgroundColor: '#f5f5f5', 
                    borderRadius: '8px 8px 0 0' 
                  }}>
                    <div>Employee Details</div>
                    <div style={{ textAlign: 'center' }}>Used</div>
                    {policyType === 'casual' && <div style={{ textAlign: 'center' }}>Carry-forwarded</div>}
                    <div style={{ textAlign: 'center' }}>
  {policyType === 'casual' ? 'Earned leave' : policyType === 'medical' ? 'Medical Leave' : 'Permission'}
</div>
                    <div style={{ textAlign: 'center' }}>Remaining</div>
                    <div style={{ textAlign: 'center' }}>Actions</div>
                  </div>

                  <div 
  ref={modalScrollRef}                  
  style={{ maxHeight: '400px', overflowY: 'auto' }}
  onScroll={(e) => {
    // Prevent scroll jump
    e.stopPropagation();
  }}
>
                    {employees.map((employee, index) => (
                      <div
                        key={employee.id || index}
                        style={{
                          display: 'grid',
                          gridTemplateColumns: policyType === 'casual' ? '2fr 1fr 1fr 1fr 1fr 100px' : '2fr 1fr 1fr 1fr 100px',
                          gap: '16px',
                          padding: '14px 16px',
                          borderBottom: '1px solid #e0e0e0',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: '#667eea',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: '600'
                          }}>
                            {employee.name.charAt(0).toUpperCase()}
                          </div>
                          <div style={{width:'180px'}}>
                            <div style={{ fontWeight: '600', color: '#333' }}>{employee.name}</div>
                            <div style={{ fontSize: '12px', color: '#999' }}>{employee.email}</div>
                          </div>
                        </div>
                        
                        <div style={{ textAlign: 'center' }}>
  <div style={{ fontWeight: '600', color: '#333' }}>
    {(() => {
      const used = getEmployeeUsed(employee);
      console.log(`📊 [DISPLAY USED] Employee ${employee.id}: ${used}`);
      return used;
    })()}
  </div>
</div>
                        
                        {policyType === 'casual' && (
                          <div style={{ textAlign: 'center' }}>
                            {editingEmployeeId === employee.id ? (
                              <input
                                type="number"
                                value={editingExtraLimit}
  onChange={(e) => {
    e.preventDefault();
    e.stopPropagation();
    setEditingExtraLimit(e.target.value);
  }}
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
  }}
  onFocus={(e) => {
    e.preventDefault();
    e.stopPropagation();
  }}
  onMouseDown={(e) => {
    e.stopPropagation();
  }}
  onKeyDown={(e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      // Save only the carry-forwarded (extra leave) field
      saveIndividualLimit(employee.id, editingExtraLimit, 'extra', null);
    }
  }}
  onWheel={(e) => {
    e.stopPropagation();
  }}
                                min="0"
                                max="365"
                                step="0.5"
                                style={{
                                  width: '60px',
                                  padding: '4px 8px',
                                  border: '2px solid #2196F3',
                                  borderRadius: '4px',
                                  fontSize: '13px',
                                  fontWeight: '600',
                                  textAlign: 'center'
                                }}
                                autoFocus={editingFieldType === 'carryforward'}
                              />
                            ) : (
                              <div style={{ 
                                fontWeight: '600', 
                                color: '#2A2A2A',
                                padding: '4px 8px',
                                backgroundColor: '#e3f2fd',
                                borderRadius: '4px',
                                fontSize: '13px',
                                cursor: 'pointer'
                              }}
                              onClick={(e) => {
  e.preventDefault();
  e.stopPropagation();
  if (policyType === 'casual') {
    setEditingEmployeeId(employee.id);
    setEditingFieldType('carryforward');
    setEditingLimit((employee.leaveBalance?.casual?.allocated_days || 0).toString());
    setEditingExtraLimit((employee.leaveBalance?.casual?.extra_leave_days || 0).toString());
  }
}}
                              >
                                {employee.leaveBalance?.casual?.extra_leave_days || 0}
                              </div>
                            )}
                          </div>
                        )}
                        
                        <div style={{ textAlign: 'center' }}>
  {editingEmployeeId === employee.id ? (
    <input
      type="number"
      value={editingLimit}
  onChange={(e) => {
    e.preventDefault();
    e.stopPropagation();
    setEditingLimit(e.target.value);
  }}
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
  }}
  onFocus={(e) => {
    e.preventDefault();
    e.stopPropagation();
  }}
  onMouseDown={(e) => {
    e.stopPropagation();
  }}
  onKeyDown={(e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      // For casual: save allocated_days
      // For medical/permission: save allocated
      if (policyType === 'casual') {
        saveIndividualLimit(employee.id, editingLimit, 'casual', null);
      } else {
        saveIndividualLimit(employee.id, editingLimit, policyType, null);
      }
    }
  }}
  onWheel={(e) => {
    e.stopPropagation();
  }}
      min="0"
      max="365"
      step="0.5"
      style={{
        width: '60px',
        padding: '4px 8px',
        border: '2px solid #2196F3',
        borderRadius: '4px',
        fontSize: '13px',
        fontWeight: '600',
        textAlign: 'center'
      }}
      autoFocus={editingFieldType === 'earned'}
    />
  ) : (
    <div style={{ 
      fontWeight: '600', 
      color: '#2A2A2A',
      padding: '4px 8px',
      backgroundColor: '#e3f2fd',
      borderRadius: '4px',
      fontSize: '13px',
      cursor: 'pointer'
    }}
    onClick={(e) => {
  e.preventDefault();
  e.stopPropagation();
  setEditingEmployeeId(employee.id);
  setEditingFieldType('earned');
  
  // ✅ FIX: Read from the correct policy type
  let currentLimit = 0;
  if (policyType === 'casual') {
    currentLimit = employee.leaveBalance?.casual?.allocated_days || 0;
  } else if (policyType === 'medical') {
    currentLimit = employee.leaveBalance?.medical?.allocated_days || 0;
  } else if (policyType === 'permission') {
    currentLimit = employee.leaveBalance?.permission?.permission_monthly_limit || 0;
  }
  
  setEditingLimit(currentLimit.toString());
  setEditingExtraLimit((employee.leaveBalance?.casual?.extra_leave_days || 0).toString());
}}
    >
      {getEmployeeLimit(employee)}
    </div>
  )}
</div>
                        
                        <div style={{ textAlign: 'center' }}>
                          <div style={{ 
                            fontWeight: '600',
                            color: getEmployeeRemaining(employee) <= 2 ? '#f44336' : '#4CAF50',
                            padding: '4px 8px',
                            backgroundColor: getEmployeeRemaining(employee) <= 2 ? '#ffebee' : '#e8f5e9',
                            borderRadius: '4px',
                            fontSize: '13px'
                          }}>
                            {getEmployeeRemaining(employee)}
                          </div>
                        </div>
                        
                        <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                          {editingEmployeeId === employee.id ? (
  <>
    <button
onClick={() => {
  // Save both fields for casual leave type
  if (policyType === 'casual') {
    // First save the carry-forwarded (extra leave) field
    saveIndividualLimit(employee.id, editingExtraLimit, 'extra', null);
    // Then save the earned leave (allocated) field
    setTimeout(() => {
      saveIndividualLimit(employee.id, editingLimit, 'casual', null);
    }, 100);
  } else {
    // For medical/permission: save allocated
    saveIndividualLimit(employee.id, editingLimit, policyType, null);
  }
}}
style={{
  padding: '4px 8px',
  backgroundColor: '#4CAF50',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '12px',
  fontWeight: '600'
}}
title="Save changes"
>
✓
</button>
    <button
      onClick={() => {
  setEditingEmployeeId(null);
  setEditingLimit('');
  setEditingExtraLimit('');
  setEditingFieldType(null);
}}
      style={{
        padding: '4px 8px',
        backgroundColor: '#f44336',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px',
        fontWeight: '600'
      }}
      title="Cancel"
    >
    ✕
    </button>
  </>
                          ) : (
                            <button
  onClick={() => {
  setEditingEmployeeId(employee.id);
  setEditingFieldType('earned');
  
  // ✅ FIX: Read from the correct policy type
  let currentLimit = 0;
  if (policyType === 'casual') {
    currentLimit = employee.leaveBalance?.casual?.allocated_days || 0;
  } else if (policyType === 'medical') {
    currentLimit = employee.leaveBalance?.medical?.allocated_days || 0;
  } else if (policyType === 'permission') {
    currentLimit = employee.leaveBalance?.permission?.permission_monthly_limit || 0;
  }
  
  setEditingLimit(currentLimit.toString());
  setEditingExtraLimit((employee.leaveBalance?.casual?.extra_leave_days || 0).toString());
}}
                              style={{
                                padding: '4px 8px',
                                color: 'white',
                                border: 'none',
                                backgroundColor:'White',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '12px',
                                fontWeight: '600',
                              }}
                              title="Edit limit"
                            >
                              <img src="/Images/Edit.png" alt="✏️" />
                            </button>
                          
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '12px',
            marginTop: '20px',
            paddingTop: '16px',
            borderTop: '2px solid #e0e0e0'
          }}>
          </div>
        </div>
      </div>,
      document.body
    );
  };

  const EmailComposerModal = () => {
    return ReactDOM.createPortal(
      <div className="admin-settings-composer-overlay" 
      // onClick={() => setShowEmailComposer(false)}
      >
        <div 
          className="admin-settings-composer-modal" 
          // onClick={(e) => e.stopPropagation()}
        >
          <div className="admin-settings-composer-header">
            <h2>Ã°Å¸â€œÂ§ Compose & Send Email</h2>
            <button 
              className="admin-settings-composer-close" 
              onClick={() => setShowEmailComposer(false)}
            >
              ✕
            </button>
          </div>

          {composerStatus.show && (
            <div className={`admin-settings-status-message ${composerStatus.type}`}
                 style={{ margin: '16px' }}>
              {composerStatus.message}
            </div>
          )}

          <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            
            <div className="admin-settings-form-group">
              <label>Email Template</label>
              <select 
                value={emailComposer.emailType}
                onChange={(e) => {
                  const template = getEmailTemplate(e.target.value);
                  setEmailComposer({
                    ...emailComposer,
                    emailType: e.target.value,
                    subject: template.subject,
                    body: template.body
                  });
                }}
                style={{
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              >
                <option value="custom">Ã°Å¸â€œÂ Custom Email</option>
                <option value="approval">Ã¢Å“â€¦ Leave Approved Template</option>
                <option value="rejection">Ã¢ÂÅ’ Leave Rejected Template</option>
                <option value="notification">Ã°Å¸â€œÂ¢ General Notification</option>
              </select>
              <p className="admin-settings-field-description">
                Select a template to auto-fill subject and body, or write custom email
              </p>
            </div>

            <div className="admin-settings-form-group">
              <label>Recipient Email *</label>
              <input 
                type="email" 
                value={emailComposer.recipientEmail}
                onChange={(e) => setEmailComposer({...emailComposer, recipientEmail: e.target.value})}
                placeholder="employee@company.com"
                style={{
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  width: '100%',
                  fontSize: '14px'
                }}
              />
            </div>

            <div className="admin-settings-form-group">
              <label>Recipient Name (Optional)</label>
              <input 
                type="text" 
                value={emailComposer.recipientName}
                onChange={(e) => setEmailComposer({...emailComposer, recipientName: e.target.value})}
                placeholder="John Doe"
                style={{
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  width: '100%',
                  fontSize: '14px'
                }}
              />
            </div>

            <div className="admin-settings-form-group">
              <label>Subject *</label>
              <input 
                type="text" 
                value={emailComposer.subject}
                onChange={(e) => setEmailComposer({...emailComposer, subject: e.target.value})}
                placeholder="Email subject"
                style={{
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  width: '100%',
                  fontSize: '14px'
                }}
              />
            </div>

            <div className="admin-settings-form-group">
              <label>Email Body *</label>
              <textarea 
                value={emailComposer.body}
                onChange={(e) => setEmailComposer({...emailComposer, body: e.target.value})}
                placeholder="Write your email here..."
                style={{
                  padding: '12px',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  width: '100%',
                  minHeight: '250px',
                  fontSize: '14px',
                  fontFamily: 'monospace',
                  resize: 'vertical'
                }}
              />
              <p className="admin-settings-field-description">
                Ã°Å¸â€™Â¡ Use placeholders like [Employee Name], [Leave Type], [Start Date], etc.
              </p>
            </div>

            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button
                onClick={() => {}}
                disabled={composerLoading}
                style={{
                  flex: 1,
                  padding: '12px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: composerLoading ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  opacity: composerLoading ? 0.6 : 1
                }}
              >
                {composerLoading ? 'Ã°Å¸â€œÂ¤ Sending...' : 'Ã°Å¸â€œÂ¤ Send Email'}
              </button>

              <button
                onClick={() => setShowEmailComposer(false)}
                style={{
                  flex: 1,
                  padding: '12px',
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  };

  return (
    <div className="admin-settings-navbar" style={{overflow:'hidden'}}>
      <div className="admin-settings-nav"><Navbar /></div>

      <div className="admin-settings">
        {/* White top bar — replaces blue Mainbar */}
            <TopBar />

        {/* Page header */}
        <div className="admin-settings-header">
          <div>
            <h1>System Settings</h1>
            <p className="admin-settings-subtitle">Configure system-wide settings and preferences</p>
          </div>

          {/* Search */}
          <div className="admin-settings-search-container" ref={searchInputRef}>
            <svg width="13" height="13" fill="none" viewBox="0 0 20 20"
              style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', pointerEvents:'none', opacity:0.5 }}>
              <path d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16zM18 18l-4.35-4.35" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              onFocus={() => searchQuery && setShowSearchResults(true)}
              placeholder="Search settings…"
              className="admin-settings-search-input"
            />
            {searchQuery && (
              <button onClick={clearSearch} style={{
                position:'absolute', right:10, top:'50%', transform:'translateY(-50%)',
                padding:'3px 8px', background:'#e9ecef', border:'none', borderRadius:4,
                cursor:'pointer', fontSize:11, fontWeight:600, color:'#666'
              }}>✕ Clear</button>
            )}

            {/* Search results dropdown */}
            {showSearchResults && searchQuery && (
              <div style={{
                position:'absolute', top:'calc(100% + 8px)', left:0, right:0,
                background:'#fff', border:'1px solid #e5e7eb', borderRadius:12,
                boxShadow:'0 8px 24px rgba(0,0,0,0.12)', zIndex:9999,
                maxHeight:400, overflowY:'auto'
              }}>
                {highlightedFields.length > 0 ? (
                  <>
                    <div style={{ padding:'10px 14px', background:'#f8fafc', borderBottom:'1px solid #f3f4f6', fontSize:11, fontWeight:700, color:'#9ca3af', textTransform:'uppercase', letterSpacing:'0.05em', borderRadius:'12px 12px 0 0' }}>
                      {highlightedFields.length} section{highlightedFields.length > 1 ? 's' : ''} found
                    </div>
                    {highlightedFields.map(key => (
                      <div key={key} onClick={() => scrollToSection(key)}
                        style={{ padding:'14px', borderBottom:'1px solid #f3f4f6', cursor:'pointer', transition:'background 0.15s' }}
                        onMouseEnter={e => e.currentTarget.style.background='#f8fafc'}
                        onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                        <div style={{ fontWeight:600, fontSize:14, color:'#111827', marginBottom:4 }}>{searchableContent[key].title}</div>
                        <div style={{ fontSize:12, color:'#6b7280' }}>{searchableContent[key].description}</div>
                      </div>
                    ))}
                  </>
                ) : (
                  <div style={{ padding:'32px 14px', textAlign:'center', color:'#9ca3af', fontSize:13 }}>
                    No results for "{searchQuery}"
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Status messages */}
        {saveStatus.show && (
          <div className={`admin-settings-status-message ${saveStatus.type}`}>
            {saveStatus.message}
          </div>
        )}
        {testEmailStatus.show && (
          <div className={`admin-settings-status-message ${testEmailStatus.type}`}
               style={{ marginTop: saveStatus.show ? 8 : 0 }}>
            {testEmailStatus.message}
          </div>
        )}

        {/* ── Page body ── */}
        <div className="admin-settings-body">

          {/* Leave Policy Configuration */}
          <div className="admin-settings-section admin-settings-leave-policy">
            <h2>Leave Policy Configuration</h2>

            <div className="admin-settings-form-group">
              <button className="admin-settings-view-policy-btn"
                onClick={() => handleOpenPolicyModal('casual')}
                title="View employees with this leave type">
                Annual Earned Leave Days
              </button>
            </div>

            <div className="admin-settings-form-group">
              <button className="admin-settings-view-policy-btn"
                onClick={() => handleOpenPolicyModal('medical')}
                title="View employees with this leave type">
                Annual Medical Leave Days
              </button>
            </div>

            <div className="admin-settings-form-group" style={{ marginBottom:0 }}>
              <button className="admin-settings-view-policy-btn"
                onClick={() => handleOpenPolicyModal('permission')}
                title="View employees with this leave type">
                Permission Requests Per Month
              </button>
            </div>
          </div>

          {/* Email Configuration */}
          <div className="admin-settings-section admin-settings-email-config">
            <h2>Email Configuration</h2>

            {/* Current sender */}
            {selectedUser && (
              <div className="current-sender-badge">
                <div className="current-sender-avatar">
                  {selectedUser.name.charAt(0).toUpperCase()}
                </div>
                <div className="current-sender-info">
                  <div className="current-sender-label">Current Email Sender</div>
                  <div className="current-sender-name">{selectedUser.name}</div>
                  <div className="current-sender-email">{selectedUser.email}</div>
                  <div className="current-sender-role">{selectedUser.role} {selectedUser.department}</div>
                </div>
              </div>
            )}

            {/* SMTP Server */}
            <div className="admin-settings-form-group">
              <label>SMTP Server</label>
              <input
                type="text"
                value={emailConfig.smtpServer}
                onChange={(e) => {
                  const val = e.target.value;
                  const corrected = autocorrectSMTP(val);
                  if (corrected !== val && val.length > 5) console.log(`Autocorrected: "${val}" → "${corrected}"`);
                  setEmailConfig({...emailConfig, smtpServer: corrected});
                }}
                onBlur={(e) => {
                  const corrected = autocorrectSMTP(e.target.value);
                  if (corrected !== e.target.value) {
                    setEmailConfig({...emailConfig, smtpServer: corrected});
                    alert(`✅ Autocorrected SMTP server to: ${corrected}`);
                  }
                }}
                placeholder="smtp.gmail.com"
              />
            </div>

            {/* SMTP Port */}
            <div className="admin-settings-form-group">
              <label>SMTP Port</label>
              <select
                value={emailConfig.smtpPort}
                onChange={(e) => {
                  const port = e.target.value;
                  setEmailConfig({ ...emailConfig, smtpPort: port, useTls: port === '587', useSsl: port === '465' });
                }}
              >
                <option value="587">587 (TLS) - Recommended</option>
                <option value="465">465 (SSL)</option>
                <option value="25">25 (Plain - Not Recommended)</option>
              </select>
            </div>

            {/* From Email with autocomplete */}
            <div className="admin-settings-form-group autocomplete-container">
              <label>From Email</label>
              <input
                ref={emailInputRef}
                type="email"
                value={emailConfig.fromEmail}
                onChange={(e) => handleEmailInput(e.target.value)}
                onFocus={() => emailConfig.fromEmail && handleEmailInput(emailConfig.fromEmail)}
                placeholder="noreply@company.com"
                autoComplete="off"
              />
              <p className="admin-settings-field-description">
                {emailSuggestions.length > 0
                  ? `${emailSuggestions.length} matching user${emailSuggestions.length > 1 ? 's' : ''} found`
                  : 'Email address that will appear as sender'}
              </p>
              {showEmailDropdown && emailSuggestions.length > 0 && (
                <div ref={emailDropdownRef} className="autocomplete-dropdown">
                  <div className="autocomplete-header">Select from {emailSuggestions.length} employee{emailSuggestions.length > 1 ? 's' : ''}</div>
                  {emailSuggestions.slice(0, 10).map(user => (
                    <div key={user.id} className="autocomplete-item" onClick={() => selectEmailSuggestion(user)}>
                      <div className="autocomplete-user-info">
                        <div className="autocomplete-avatar">{user.name.charAt(0).toUpperCase()}</div>
                        <div className="autocomplete-details">
                          <div className="autocomplete-name">{user.name}</div>
                          <div className="autocomplete-email">{user.email}</div>
                          <div className="autocomplete-role">{user.role} {user.department}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {emailSuggestions.length > 10 && <div className="autocomplete-footer">+ {emailSuggestions.length - 10} more results</div>}
                </div>
              )}
            </div>

            {/* From Name with autocomplete */}
            <div className="admin-settings-form-group autocomplete-container">
              <label>From Name</label>
              <input
                ref={nameInputRef}
                type="text"
                value={emailConfig.fromName}
                onChange={(e) => handleNameInput(e.target.value)}
                onFocus={() => emailConfig.fromName && handleNameInput(emailConfig.fromName)}
                placeholder="Company Leave Management"
                autoComplete="off"
              />
              {showNameDropdown && nameSuggestions.length > 0 && (
                <div ref={nameDropdownRef} className="autocomplete-dropdown">
                  <div className="autocomplete-header">Select from {nameSuggestions.length} employee{nameSuggestions.length > 1 ? 's' : ''}</div>
                  {nameSuggestions.slice(0, 10).map(user => (
                    <div key={user.id} className="autocomplete-item" onClick={() => selectNameSuggestion(user)}>
                      <div className="autocomplete-user-info">
                        <div className="autocomplete-avatar">{user.name.charAt(0).toUpperCase()}</div>
                        <div className="autocomplete-details">
                          <div className="autocomplete-name">{user.name}</div>
                          <div className="autocomplete-email">{user.email}</div>
                          <div className="autocomplete-role">{user.role} {user.department}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                  {nameSuggestions.length > 10 && <div className="autocomplete-footer">+ {nameSuggestions.length - 10} more results</div>}
                </div>
              )}
            </div>

            {/* App Password */}
            <div className="admin-settings-form-group">
              <label>App Password <span style={{color:'#ef4444'}}>*</span></label>
              <div style={{ position:'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={emailConfig.emailPassword}
                  onChange={(e) => setEmailConfig({...emailConfig, emailPassword: e.target.value})}
                  placeholder="Enter App password"
                  autoComplete="new-password"
                  style={{ paddingRight:44 }}
                />
                <button type="button" onClick={() => setShowPassword(!showPassword)} style={{
                  position:'absolute', right:12, top:'50%', transform:'translateY(-50%)',
                  background:'none', border:'none', cursor:'pointer', fontSize:16, color:'#9ca3af', padding:4
                }}>
                  {showPassword ? '🔒' : '👁'}
                </button>
              </div>
              <p className="admin-settings-field-description">
                <strong>For Gmail users:</strong> Use App Password instead of regular password<br/>
                Go to: Google Account Security → 2-Step Verification → App Passwords<br/>
                <strong>Tip:</strong> You can change to a different user by selecting a new user and entering their password
              </p>
            </div>

            {/* Save button */}
            <div className="admin-settings-save-btnmain">
              <button
                className="admin-settings-save-btn"
                onClick={saveEmailConfiguration}
                disabled={loading || !emailConfig.selectedUserId || !emailConfig.emailPassword}
              >
                {loading ? 'Saving…' : 'Save Email Settings'}
              </button>
            </div>
          </div>

        </div>{/* /admin-settings-body */}

        {/* Leave Policy Modal */}
        {showLeavePolicyModal && selectedPolicyType && (
          <LeavePolicyModal
            policyType={selectedPolicyType}
            onClose={() => { setShowLeavePolicyModal(false); setSelectedPolicyType(null); }}
          />
        )}

        {/* Email Composer Modal */}
        {showEmailComposer && <EmailComposerModal />}

      </div>{/* /admin-settings */}
    </div>
  );

};

export default SystemSettings;
